import React from "react";
import { View, Text, Image } from "react-native";
import { ProgressBar, Card, Title, Paragraph } from "react-native-paper";
import nivelEsgIcon from "../../../assets/nivel_esg.png";

import styles from "./styles";

const LoteAvaliacao = () => {
  const producao = 21000; // toneladas
  const perda = 2.5; // %
  const aproveitamento = 97.5; // %
  const scoreESG = 800; // Pontuação ESG
  const risco = "baixo"; // Risco
  const relatorioESG = [
    "utilização de biochar",
    "redução de impacto hídrico",
    "aumento do estoque de carbono",
  ];
  const areaUtilizada = 300; // hectares
  const estoqueCarbonoSolo = 3600; // t/ha
  const estoqueCarbonoTotal = 1080000; // toneladas

  // Datas de início e término da safra
  const inicioSafra = new Date("2024-08-12");
  const terminoSafra = new Date("2024-11-28");
  const hoje = new Date();

  // Cálculo do progresso da safra
  const totalPeriodoSafra = terminoSafra - inicioSafra;
  const progressoSafra = ((hoje - inicioSafra) / totalPeriodoSafra) * 100;

  return (
    <View style={styles.container}>
      <Card style={styles.card}>
        <Card.Content>
          <Title style={styles.title}>Avaliação do Lote</Title>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Produção Planejada</Text>
            <Paragraph>{producao} toneladas</Paragraph>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Perda e Aproveitamento</Text>
            <Text>
              <Text style={styles.labelBold}>Perda: </Text>
              <Text style={styles.valueText}>{perda}%</Text>
            </Text>
            <Text>
              <Text style={styles.labelBold}>Aproveitamento: </Text>
              <Text style={styles.valueText}>{aproveitamento}%</Text>
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Qualificação ESG</Text>
            <View style={styles.horizontalContainer}>
              <View style={styles.textContainer}>
                <Text>
                  <Text style={styles.labelBold}>Score ESG: </Text>
                  <Text style={styles.valueText}>{scoreESG}</Text>
                </Text>
                <Text>
                  <Text style={styles.labelBold}>Risco: </Text>
                  <Text style={styles.valueText}>{risco}</Text>
                </Text>
              </View>
              {/* <Image source={nivelEsgIcon} style={styles.imageIcon} /> */}
            </View>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Relatório ESG</Text>
            {relatorioESG.map((item, index) => (
              <Text key={index} style={styles.bulletPoint}>
                • {item}
              </Text>
            ))}
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Crédito de Carbono</Text>
            <Text>
              <Text style={styles.labelBold}>Área Utilizada: </Text>
              <Text style={styles.valueText}>{areaUtilizada} ha</Text>
            </Text>
            <Text>
              <Text style={styles.labelBold}>Estoque de Carbono por Ha: </Text>
              <Text style={styles.valueText}>{estoqueCarbonoSolo} t/ha</Text>
            </Text>
            <Text>
              <Text style={styles.labelBold}>Estoque de Carbono Total: </Text>
              <Text style={styles.valueText}>
                {estoqueCarbonoTotal} toneladas
              </Text>
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Progresso da Safra</Text>
            <ProgressBar
              progress={progressoSafra / 100}
              color="#4caf50"
              style={styles.progressBar}
            />
            <Text>{Math.min(Math.round(progressoSafra), 100)}% Concluído</Text>
          </View>
        </Card.Content>
      </Card>
    </View>
  );
};

export default LoteAvaliacao;
